"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MusicPlayer = exports.useMusicManager = void 0;
const react_1 = __importStar(require("react"));
const zustand_1 = __importDefault(require("zustand"));
const react_sound_1 = __importDefault(require("react-sound"));
const design_container_widget_1 = require("@unboared/design.container.widget");
const design_system_system_action_button_1 = require("@unboared/design.system.system_action_button");
exports.useMusicManager = (0, zustand_1.default)((set, get) => ({
    controlled: false,
    currentSong: undefined,
    position: 0,
    volume: 100,
    savedVolume: 100,
    playbackRate: 1,
    loop: true,
    playStatus: react_sound_1.default.status.PLAYING,
    setPosition: (position) => set({ position: position }),
    onPlay: () => set({ playStatus: react_sound_1.default.status.PLAYING }),
    onPause: () => set({ playStatus: react_sound_1.default.status.PAUSED }),
    onResume: () => set({ playStatus: react_sound_1.default.status.PLAYING }),
    onStop: () => set({ playStatus: react_sound_1.default.status.STOPPED, position: 0 }),
    onVolumeUp: () => set((state) => ({
        volume: state.volume >= 100 ? state.volume : state.volume + 10,
        savedVolume: state.savedVolume >= 100 ? state.savedVolume : state.savedVolume + 10
    })),
    onVolumeDown: () => set((state) => ({
        volume: state.volume <= 0 ? state.volume : state.volume - 10,
        savedVolume: state.savedVolume <= 0 ? state.savedVolume : state.savedVolume - 10
    })),
    onUnmute: () => set((state) => ({ volume: state.savedVolume })),
    onMute: () => set({ volume: 0 }),
    onToggleLoop: () => set((state) => ({ loop: !state.loop })),
    setMusic: (newSong) => set({ currentSong: newSong }),
    toggleMute: () => {
        if (get().volume > 0) {
            get().onMute();
        }
        else {
            get().onUnmute();
        }
    }
}));
const MusicPlayer = ({ source, style = {}, hidden = false, children = undefined, blurred = false, size = 20 }) => {
    const playStatus = (0, exports.useMusicManager)((state) => state.playStatus);
    const currentSong = (0, exports.useMusicManager)((state) => state.currentSong);
    const position = (0, exports.useMusicManager)((state) => state.position);
    const setPosition = (0, exports.useMusicManager)((state) => state.setPosition);
    const volume = (0, exports.useMusicManager)((state) => state.volume);
    const playbackRate = (0, exports.useMusicManager)((state) => state.playbackRate);
    const loop = (0, exports.useMusicManager)((state) => state.loop);
    const onStop = (0, exports.useMusicManager)((state) => state.onStop);
    const setMusic = (0, exports.useMusicManager)((state) => state.setMusic);
    (0, react_1.useEffect)(() => {
        setMusic(source);
    }, []);
    return (react_1.default.createElement(react_1.default.Fragment, null,
        currentSong && (react_1.default.createElement(react_sound_1.default, { url: currentSong, playStatus: playStatus, playFromPosition: position, volume: volume, playbackRate: playbackRate, loop: loop, onLoading: ({ bytesLoaded, bytesTotal }) => console.log(`${bytesLoaded / bytesTotal * 100}% loaded`), onLoad: () => console.log('[AmbianceSound] Loaded'), onPlaying: ({ position }) => { }, onPause: ({ position }) => { console.log('Paused at ', position); setPosition(position); }, onResume: () => console.log('[AmbianceSound] Resumed'), onStop: () => console.log('[AmbianceSound] Stopped'), onFinishedPlaying: onStop })),
        !hidden && (children ||
            react_1.default.createElement(MusicPlayerComponent, { style: style, size: size, blurred: blurred }))));
};
exports.MusicPlayer = MusicPlayer;
const MusicPlayerComponent = ({ style, size, blurred }) => {
    const playStatus = (0, exports.useMusicManager)((state) => state.playStatus);
    const onPlay = (0, exports.useMusicManager)((state) => state.onPlay);
    const onPause = (0, exports.useMusicManager)((state) => state.onPause);
    return (react_1.default.createElement(design_container_widget_1.Widget, { style: style, blurred: blurred },
        react_1.default.createElement(design_system_system_action_button_1.SystemActionButton, { onIcon: 'play', offIcon: 'pause', onPress: playStatus === react_sound_1.default.status.PLAYING ? onPause : onPlay, active: playStatus !== react_sound_1.default.status.PLAYING, size: size })));
};
//# sourceMappingURL=music.js.map